import React from 'react';
import { useNavigate } from 'react-router-dom';
import './admin.css';

const AdminDashboard = () => {
    const navigate = useNavigate();

    const handleLogout = () => {
        localStorage.removeItem('jwtToken');
        localStorage.removeItem('userRole');
        navigate('/login');
    };

    return (
        <div className="admin-dashboard">
            <div className="welcome-header">
                <h1>Welcome to Admin Dashboard</h1>
                <p>Manage your venue and bookings efficiently</p>
            </div>
            <div className="admin-content">
                <div className="admin-actions">
                    <button onClick={() => navigate('/admin/users')}>
                        Manage Users
                    </button>
                    <button onClick={() => navigate('/admin/events')}>
                        Manage Events
                    </button>
                    <button onClick={() => navigate('/admin/bookings')}>
                        View All Bookings
                    </button>
                    <button onClick={handleLogout} className="logout-btn">
                        Logout
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AdminDashboard;